(function() {
  var roots = document.querySelectorAll('[data-other-products-root]');
  if (!roots.length) return;

  var instances = [];
  var resizeTimer;

  function isMobile() {
    return window.matchMedia('(max-width: 1023px)').matches;
  }

  function destroyAll() {
    instances.forEach(function(s) {
      if (s && typeof s.destroy === 'function') {
        s.destroy(true, true);
      }
    });
    instances = [];
  }

  function initAll() {
    if (typeof Swiper === 'undefined') return;
    destroyAll();
    if (!isMobile()) return;
    roots.forEach(function(root) {
      var el = root.querySelector('.other-products__swiper');
      var pagination = root.querySelector('.other-products__pagination');
      if (!el || !pagination) return;
      var s = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: false,
        speed: 500,
        touchStartPreventDefault: false,
        noSwiping: true,
        noSwipingClass: 'product-card__tags',
        nested: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 16
          }
        },
        pagination: {
          el: pagination,
          clickable: true
        }
      });
      instances.push(s);
    });
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  window.addEventListener('resize', onResize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-other-products-root]') || e.target.hasAttribute('data-other-products-root')) {
      initAll();
    }
  });
})();
